import {
  orderedStoreLinks,
  StoreLinkList,
  StoreRailBlock,
} from "@softmax/product-ux/catalog";
import type { PreviewContent } from "../content/preview-content.types";
import { curatedGuideUrl } from "@softmax/web-features/coworlds";
import { site } from "@softmax/web-addresses/discovery";
import {
  EditableLinks,
  LinksSectionGate,
  LockedRegion,
} from "../../store-editor";

export function StoreLinks({ content }: { content: PreviewContent }) {
  const guide = curatedGuideUrl(content.slug.split("/")[0]);
  const ordered = orderedStoreLinks(content.details.links);

  if (guide) {
    ordered.unshift({
      title: "Game guide (for people)",
      href: guide.replace(site.canonicalOrigin, ""),
    });
  }

  return (
    <LinksSectionGate
      hasContent={ordered.length > 0 || content.creatorLinks.length > 0}
    >
      <StoreRailBlock label="Links">
        {ordered.length ? (
          <LockedRegion label="Set by Softmax">
            <StoreLinkList links={ordered} />
          </LockedRegion>
        ) : null}
        <EditableLinks
          creatorLinks={content.creatorLinks}
          hasLockedLinks={ordered.length > 0}
        />
      </StoreRailBlock>
    </LinksSectionGate>
  );
}
